module.exports = __webpack_public_path__ + "img/close-banner.aaca1010.svg";